import { IState } from './Worksale.reducer';

export interface IActions {
  [SalesProcessingActionsTypes.setCustomerId]?: IState['CustomerId'];
  [SalesProcessingActionsTypes.setUnAppliedCustomerId]?: IState['UnAppliedCustomerId'];
  [SalesProcessingActionsTypes.setUnAppliedCustomerPurchaseOrder]?: IState['UnAppliedCustomerPurchaseOrder'];
  [SalesProcessingActionsTypes.setWorksaleId]?: IState['WorksaleId'];
  [SalesProcessingActionsTypes.setWorksaleDeliveryId]?: IState['WorksaleDeliveryId'];
  [SalesProcessingActionsTypes.setSalesEntity]?: IState['salesEntity'];
  [SalesProcessingActionsTypes.setWorksaleLineId]?: IState['WorksaleLineId'];
  [SalesProcessingActionsTypes.setPriceOverrideScreenType]?: IState['priceOverrideScreenType'];
  [SalesProcessingActionsTypes.setPriceOverrideDialogOpen]?: IState['priceOverrideDialogOpen'];
  [SalesProcessingActionsTypes.setPriceOverrideAuthRequestedScreen]?: IState['priceOverrideAuthRequestedScreen'];
  [SalesProcessingActionsTypes.setPriceOverrideDetailSummary]?: IState['priceOverrideDetailSummary'];
  [SalesProcessingActionsTypes.setMultipleBomState]?: IState['multipleBomOpen'];
  [SalesProcessingActionsTypes.setKitStatus]?: IState['kitStatus'];
  [SalesProcessingActionsTypes.setSelectedBomCode]?: IState['selectedBomCode'];
  [SalesProcessingActionsTypes.setBomList]?: IState['bomList'];
  [SalesProcessingActionsTypes.setOrderRecalled]?: IState['orderRecalled'];
  [SalesProcessingActionsTypes.setLostSaleDialog]?: IState['lostSaleDialog'];
  [SalesProcessingActionsTypes.setAutoSupplyQuantity]?: IState['autoSupplyQuantity'];
  [SalesProcessingActionsTypes.setDisableAutoSupplyQuantity]?: IState['disableAutoSupplyQuantity'];
  [SalesProcessingActionsTypes.setLineEdit]?: IState['isLineEdit'];
  [SalesProcessingActionsTypes.setProcessingProblemsDialogOpen]?: IState['processingProblemsDialogOpen'];
  [SalesProcessingActionsTypes.setProcessingProblemsDialog]?: IState['processingProblemsDialog'];
  [SalesProcessingActionsTypes.setWorksaleDeliverySummary]?: IState['worksaleDeliverySummary'];
  [SalesProcessingActionsTypes.setVehiclePartId]?: IState['VehiclePartId'];
  [SalesProcessingActionsTypes.setVehicleProductId]?: IState['VehicleProductId'];
  [SalesProcessingActionsTypes.setQuantity]?: IState['Quantity'];
  [SalesProcessingActionsTypes.setPartDescription]?: IState['PartDescription'];
  [SalesProcessingActionsTypes.setItemDescription]?: IState['ItemDescription'];
  [SalesProcessingActionsTypes.setWorksaleLookupPanelOpen]?: IState['worksaleLookupPanelOpen'];
}

export enum SalesProcessingActionsTypes {
  setWorksaleId = 'setWorksaleId',
  setWorksaleDeliveryId = 'setWorksaleDeliveryId',
  setWorksaleLineId = 'setWorksaleLineId',
  setCustomerId = 'setCustomerId',
  setSalesEntity = 'setSalesEntity',
  setUnAppliedCustomerId = 'setUnAppliedCustomerId',
  setUnAppliedCustomerPurchaseOrder = 'setUnAppliedCustomerPurchaseOrder',
  setPriceOverrideScreenType = 'setPriceOverrideScreenType',
  setPriceOverrideDialogOpen = 'setPriceOverrideDialogOpen',
  setPriceOverrideAuthRequestedScreen = 'setPriceOverrideAuthRequestedScreen',
  setPriceOverrideDetailSummary = 'setPriceOverrideDetailSummary',
  setMultipleBomState = 'setMultipleBomState',
  setBomList = 'setBomList',
  setKitStatus = 'setKitStatus',
  setSelectedBomCode = 'setSelectedBomCode',
  setOrderRecalled = 'setOrderRecalled',
  setLostSaleDialog = 'setLostSaleDialog',
  setAutoSupplyQuantity = 'setAutoSupplyQuantity',
  setDisableAutoSupplyQuantity = 'setDisableAutoSupplyQuantity',
  setLineEdit = 'setLineEdit',
  setProcessingProblemsDialogOpen = 'setProcessingProblemsDialogOpen',
  setProcessingProblemsDialog = 'setProcessingProblemsDialog',
  setWorksaleDeliverySummary = 'setWorksaleDeliverySummary',
  setVehiclePartId = 'setVehiclePartId',
  setVehicleProductId = 'setVehicleProductId',
  setQuantity = 'setQuantity',
  setPartDescription = 'setPartDescription',
  setItemDescription = 'setItemDescription',
  setWorksaleLookupPanelOpen = 'setWorksaleLookupPanelOpen'
}
